const isBoolean = (val: any) => typeof val === 'boolean';

export default isBoolean;
